'use client';
import classNames from 'classnames';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { useEffect, useState } from 'react';
import gtm from 'eco-design-reliance/gtm';
import SearchAIcon from './SearchAIcon';

export default function SearchV1({ prefixCls }: { prefixCls: string }) {
    const [openA, setOpenA] = useState(false);
    const classes = classNames(`${prefixCls}-bar-item ${prefixCls}-bar-search`, {
        [`${prefixCls}-search-open`]: openA,
    });
    const toggleHandle = () => {
        const openA2 = !openA;
        setOpenA(openA2);
        EcoDesignEventsBus.emit('ef-header-nav-close');

        gtm.push({
            event: 'uaEvent',
            event_name: 'top_function',
            button_name: 'Search',
            __btn_id1: `${prefixCls}-bar-search`,
            __btn_id2: `header-search`,
            __btn_type: 'common',
        });
    };
    useEffect(() => {
        EcoDesignEventsBus.on('ef-header-search-close', () => {
            setOpenA(false);
        });
    }, []);

    return (
        <button className={`${classes} GtmModuleData-btn-commo`} onClick={toggleHandle} aria-label="search" data-btn-id="header-search">
            <SearchAIcon />
        </button>
    );
}
